import React from 'react';
import cn from 'classnames';
import {useField, useFormikContext} from 'formik';
import IconInfo from '../../components/icon/IconInfo';
import Tooltip from '../Tooltip';

type Props = {
  className?: string
  label?: string
  value?: [string, string]
  name: [string, string]
  currencies: string[]
  id: string
  tooltip?: React.ReactNode
  placeholder?: string
  type?: string
  autoComplete?: string
};

export default function UIPrice({
                                  id, label, className, tooltip, name, currencies, value, ...props
                                }: Props) {
  const [fieldCurrency, metaCurrency] = useField({...props, name: name[0], value: value?.[0]});
  const [fieldAmount, metaAmount] = useField({...props, name: name[1], value: value?.[1]});
  const {values, handleChange} = useFormikContext()


  return (
    <>
      <label htmlFor={id} className="block">
        {label}
        {tooltip &&
          <>
            <Tooltip content={tooltip}
                     label={`${id}_label_tip`} className="pl-0.5">
              <IconInfo className="text-gray-dark "/>
            </Tooltip>
          </>
        }
      </label>
      <div className={cn(className, 'mt-2')}>
        <div className="flex">
          <select {...fieldCurrency} id={name[0]} {...props} className={cn(
            'py-2 focus:border-blue-focus block border-gray border rounded-md rounded-r-none border-r-0',
            {'border-red focus:border-red': metaCurrency.error && metaCurrency.touched},
          )}>
            {currencies.sort().map((currency) => (
              <option key={currency} value={currency.toLowerCase()}>{currency.toUpperCase()}</option>
            ))}
          </select>
          <input type="number" {...fieldAmount} {...props} id={name[1]}
                 className={cn(
                   'py-2 focus:border-blue-focus block w-full border-gray border rounded-none rounded-r-md',
                   {'border-red focus:border-red': metaAmount.error && metaAmount.touched},
                 )}/>
        </div>
        {(metaCurrency.error || metaAmount.error) && (metaCurrency.touched || metaAmount.touched) &&
          <>
            <div className="text-xs text-red mt-1 ml-2">{metaCurrency.error}</div>
            <div className="text-xs text-red mt-1 ml-2">{metaAmount.error}</div>
          </>
        }
      </div>
    </>
  );
}
